import React, { memo } from 'react';

// Star Icon Component
const StarIcon = ({
  className
}) => <svg className={className} fill="currentColor" viewBox="0 0 20 20" data-id="element-182">
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-183" />
  </svg>;

// Main Testimonials Component
export const Testimonials = () => {
  return (
    // Section container with a subtle background color for contrast
    <div className="py-16 sm:py-24 bg-gray-50/50" data-id="element-184">
      <div className="container mx-auto px-4 sm:px-6 max-w-5xl" data-id="element-185">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-186">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-187">
            Life-Changing Results You Can Feel
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-188">
            Don't take our word for it. See how Clarity is helping people leave the brain fog behind and get their spark back.
          </p>
        </div>

        {/* Grid for Testimonial Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-189">

          {/* --- Testimonial Card 1: The Busy Mom --- */}
          <div className="bg-white rounded-xl p-6 sm:p-8 flex flex-col shadow-lg border border-gray-100 transform hover:-translate-y-1 transition-transform duration-300" data-id="element-190">
            <div className="flex items-center mb-4" data-id="element-191">
              <img
              // Using a more "real" looking photo. Less polished, more authentic.
              src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80" alt="Photo of Sarah K." className="w-14 h-14 rounded-full object-cover" data-id="element-192" />
              <div className="ml-4" data-id="element-193">
                <p className="font-semibold text-gray-900" data-id="element-194">Sarah K.</p>
                <p className="text-sm text-gray-500" data-id="element-195">Chicago, IL</p>
                {/* "Verified Buyer" tag is a huge trust signal */}
                <p className="text-xs font-bold text-teal-600 mt-1" data-id="element-196">✓ Verified Buyer</p>
              </div>
            </div>
            <div className="mb-3 flex items-center" data-id="element-197">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400" data-id="element-198" />)}
            </div>
            {/* Headline in the customer's "voice" */}
            <h3 className="font-bold text-lg mb-3 text-gray-800" data-id="element-199">"The 'mom fog' is finally gone."</h3>
            <blockquote className="text-gray-700 text-base" data-id="element-200">
              {/* More conversational, less perfect language */}
              "Honestly, I thought being exhausted and forgetting everything was just my life now with two kids and a full-time job. I'd stand in the kitchen and couldn't remember why I walked in there. After about two weeks on Clarity, it was like the lights came back on. I'm not just 'getting by' anymore. I'm actually present with my family after work. It's a game-changer."
            </blockquote>
          </div>

          {/* --- Testimonial Card 2: The Skeptic Professional --- */}
          <div className="bg-white rounded-xl p-6 sm:p-8 flex flex-col shadow-lg border border-gray-100 transform hover:-translate-y-1 transition-transform duration-300" data-id="element-201">
            <div className="flex items-center mb-4" data-id="element-202">
              <img
              // A more natural, less "posed" photo
              src="https://images.unsplash.com/photo-1557862921-37829c790f19?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80" alt="Photo of Mike T." className="w-14 h-14 rounded-full object-cover" data-id="element-203" />
              <div className="ml-4" data-id="element-204">
                <p className="font-semibold text-gray-900" data-id="element-205">Mike T.</p>
                <p className="text-sm text-gray-500" data-id="element-206">Austin, TX</p>
                <p className="text-xs font-bold text-teal-600 mt-1" data-id="element-207">✓ Verified Buyer</p>
              </div>
            </div>
            <div className="mb-3 flex items-center" data-id="element-208">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400" data-id="element-209" />)}
            </div>
            <h3 className="font-bold text-lg mb-3 text-gray-800" data-id="element-210">"Was skeptical... now I'm a believer."</h3>
            <blockquote className="text-gray-700 text-base" data-id="element-211">
              {/* Acknowledges skepticism, which is very authentic */}
              "I've wasted so much money on supplements that do absolutely nothing, so I was 99% sure this would be the same. My wife ordered it. I have to say, I was wrong. The biggest thing for me is coding. My focus would be shot by 2 PM. Now I can actually power through the whole day without hitting a wall. Plus they actually taste good, not like most of that other junk."
            </blockquote>
          </div>

          {/* --- Testimonial Card 3: The Active Retiree --- */}
          <div className="bg-white rounded-xl p-6 sm:p-8 flex flex-col shadow-lg border border-gray-100 transform hover:-translate-y-1 transition-transform duration-300" data-id="element-212">
            <div className="flex items-center mb-4" data-id="element-213">
              <img
              // A friendly, approachable, and age-appropriate photo
              src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80" alt="Photo of David R." className="w-14 h-14 rounded-full object-cover" data-id="element-214" />
              <div className="ml-4" data-id="element-215">
                <p className="font-semibold text-gray-900" data-id="element-216">David R.</p>
                <p className="text-sm text-gray-500" data-id="element-217">Miami, FL</p>
                <p className="text-xs font-bold text-teal-600 mt-1" data-id="element-218">✓ Verified Buyer</p>
              </div>
            </div>
            <div className="mb-3 flex items-center" data-id="element-219">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400" data-id="element-220" />)}
            </div>
            <h3 className="font-bold text-lg mb-3 text-gray-800" data-id="element-221">"Feel 10 years younger, mentally."</h3>
            <blockquote className="text-gray-700 text-base" data-id="element-222">
              {/* Specific, relatable problem for the demographic */}
              "My short-term memory was getting embarrassing. I'd forget names seconds after hearing them. I just felt... slow. My daughter recommended these and I've been taking them for about two months. My mind feels so much sharper. I'm remembering things, I'm quicker in conversation, and I have the energy to actually enjoy my retirement. It's been a blessing."
            </blockquote>
          </div>

        </div>
      </div>
    </div>
  );
};

// Using memo for performance, although not strictly necessary if no props are passed.
// It's good practice if the component might get props in the future.
export default memo(Testimonials);